export const style = {
  cardContainer: {
    marginBottom: "1.6rem",
    padding: "1.2rem 0.8rem",
    borderRadius: "0.8rem",
    background: "var(--neutral-100)",
    width: "100%",
  },
  footer: { marginTop: "0.8rem", borderTop: "0.1rem solid var(--gray-20)" },
  footerText: {
    display: "flex",
    alignItems: "center",
    color: "var(--gray-500)",
    fontSize: "1.2rem",
    fontWeight: 400,
    "& > span": {
      color: "var(--gray-800)",
      fontSize: "1.2rem",
      fontWeight: 400,
    },
  },
  hideShowBlock: {
    display: {
      xs: "none",
      md: "block",
    },
  },
  patientNameSpace: { margin: "0.6rem 0rem 0rem 0rem" },
  spacing: { margin: "0.6rem 0rem 0.6rem 0rem" },
  buttonContainer: {
    marginTop: "0.8rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
  },
  directionButton: {
    display: { xs: "none", md: "flex" },
    width: "100%",
  },
  headerIcon: {
    width: "5.6rem",
    height: "5.6rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "2.8rem",
    border: "0.2rem solid var(--teal-500)",
    background: "var(--blue-50)",
  },
  clinicInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.8rem",
  },
  clinicLocation: {
    display: { xs: "flex", md: "none" },
    alignItems: "center",
    gap: "0.8rem",
  },
  mapText: {
    color: "var(--orange-500)",
    fontSize: "1.2rem",
    fontWeight: 500,
    cursor: "pointer",
  },
  contactSupportButton: {
    display: { xs: "flex", md: "none" },
  },

  contactSupportOrChatButton: {
    display: { xs: "flex", md: "none" },
    alignItems: "center",
    justifyContent: "center",
    width: "5.6rem",
    height: "4.8rem",
    padding: "0.6rem 0rem",
    gap: "0.8rem",
    background: "var(--orange-500)",
    borderRadius: "1.8rem",
    cursor: "pointer",
  },
};
